export enum TipoServicoEnum {
  BATERIA = "Carga de bateria",
  CHAVEIRO = "Chaveiro",
  TROCA_PNEU = "Troca de pneu",
  GUINCHO = "Guincho",
  TRANSPORTE_ASSOCIADO = "Transporte ao associado",
  PATINS = "Patins",
  HORA_TRABALHADA = "Hora Trabalhada",
  HORA_PARADA = "Hora Parada",
}

export function getEnumNameByDescription(desc: string): string {
  switch (desc) {
    case TipoServicoEnum.BATERIA:
      return "BATERIA";
    case TipoServicoEnum.CHAVEIRO:
      return "CHAVEIRO";
    case TipoServicoEnum.GUINCHO:
      return "GUINCHO";
    case TipoServicoEnum.TRANSPORTE_ASSOCIADO:
      return "TRANSPORTE_ASSOCIADO";
    case TipoServicoEnum.TROCA_PNEU:
      return "TROCA_PNEU";
    default:
      return "";
  }
}
